import React from 'react';
import { useCurrentUser } from 'security';
import { FullProviderUserInfo } from '../../../domain/types';
import { AppAccessInput } from './AppAccessInput';
import { AutocompleteProviderInput } from './AutocompleteProviderInput';
import { EditableEmailInput, ReadOnlyEmailInput } from './EmailInput';
import { FirstNameInput } from './FirstNameInput';
import { LastNameInput } from './LastNameInput';
import { ReadonlyProviderInput } from './ReadonlyProviderInput';
import { DummyUserStatus, UserStatus } from './UserStatus';
import { ApplicationRootUrl, useApplicationRoot } from 'common/component/ApplicationRootContext';

const COMMON_INPUT_SIZE_PROPS = {
    inputHeight: 40,
    inputWidth: 320,
    size: 500,
}
export const NewUserFormContent = () => {
    const currentUser = useCurrentUser();
    let isBhpnAdmin = ['THE_BHPN_ADMIN', 'THE_BHPN_ADMIN_WITH_PROVIDER_SUPPORT'].includes(currentUser?.role ?? '');
    const applicationRoot = useApplicationRoot();
    if (applicationRoot === ApplicationRootUrl.AZURE_INTERNAL_UM_PROVIDER_ROUTE_NAME) {
        isBhpnAdmin = false;  
    }
    return (
        <>
            <EditableEmailInput data-testid="um-new-email-input" {...COMMON_INPUT_SIZE_PROPS} />
            <FirstNameInput data-testid="um-new-first-name-input" {...COMMON_INPUT_SIZE_PROPS} />
            <LastNameInput data-testid="um-new-last-name-input" {...COMMON_INPUT_SIZE_PROPS} />
            {isBhpnAdmin ?
                <AutocompleteProviderInput /> :
                <ReadonlyProviderInput providerGuid={currentUser?.provider?.guid ?? ''}
                    providerName={currentUser?.provider?.name ?? ''} />}
            <DummyUserStatus />
            <AppAccessInput canSetUserAdmin={isBhpnAdmin} canSetClientReport={isBhpnAdmin || currentUser?.canManageClientReport}/>
        </>
    );
};

type EditUserFormContentProps = {
    user: FullProviderUserInfo;
};
export const EditUserFormContent = ({ user }: EditUserFormContentProps) => {
    const currentUser = useCurrentUser();
    let isBhpnAdmin = ['THE_BHPN_ADMIN', 'THE_BHPN_ADMIN_WITH_PROVIDER_SUPPORT'].includes(currentUser?.role ?? '');
    const applicationRoot = useApplicationRoot();
    if (applicationRoot === ApplicationRootUrl.AZURE_INTERNAL_UM_PROVIDER_ROUTE_NAME) {
        isBhpnAdmin = false;  
    }
    return (
        <>
            <ReadOnlyEmailInput width={320} height={40} display='inline-block' />
            <FirstNameInput data-testid="um-first-name-input" {...COMMON_INPUT_SIZE_PROPS} />
            <LastNameInput data-testid="um-last-name-input" {...COMMON_INPUT_SIZE_PROPS} />
            <ReadonlyProviderInput providerGuid={user.providerGuid}
                providerName={user.providerName} />
            <UserStatus status={user.status} oktaId={user.oktaId}
                canSetUserStatus={!user.userManagementAdminAccess || isBhpnAdmin} />
            <AppAccessInput canSetUserAdmin={isBhpnAdmin} canSetClientReport={isBhpnAdmin || currentUser?.canManageClientReport}/>
        </>
    );
};
